<section class="recent-donors-container">
    <ng-container *ngIf="loading$ | async; else content">
        <div class="recent-donors-state">
            Loading...
        </div>
    </ng-container>

    <ng-template #content>
        <div *ngIf="error$ | async as err" class="recent-donors-error">
            Error: {{ err }}
        </div>

        <don-donations-list class="recent-donors-feed" [vms]="(vms$ | async) || []"
            [donorsCount]="(donorsCount$ | async) || 0" (like)="onLike($event)"
            (share)="onShare($event)">
        </don-donations-list>
    </ng-template>
</section>